import { CountUp } from 'countup.js';
function menuBtn() {
    $('.hamburger').click(function(e) {
        e.preventDefault()
        $(this).toggleClass('is-active');
        $('.menu-overlay').toggleClass('active');
    });
}
const wow = new WOW(
    {
      boxClass:     'wow',      // animated element css class (default is wow)
      animateClass: 'animated', // animation css class (default is animated)
      offset:       0,          // distance to the element when triggering the animation (default is 0)
      mobile:       true,       // trigger animations on mobile devices (default is true)
      live:         true,       // act on asynchronously loaded content (default is true)
      callback:     function(box) {
        // the callback is fired every time an animation is started
        // the argument that is passed in is the DOM node being animated
      },
      scrollContainer: null // optional scroll container selector, otherwise use window
    }
);

function handlePreloader()
{
    window.onload = function () {
        // console.log('works');

        $('.preloader').fadeOut(500, function(){
            $('.preloader').remove();
        });
    }

    setTimeout(function () {
        $('.preloader').fadeOut(500, function(){
            $('.preloader').remove();
        });
    }, 4000);
}

function counterItems(){
    $('[data-count]').each(function(index, element) {
        var endValue = element.getAttribute('count-item');
        var queueCountAnimation = new CountUp(element, endValue);
        queueCountAnimation.start();
    });
};

$( document ).ready(function() {

    $("#query-btn").click(function(){
        var term = $("#s-query").val();
        var page = $("#s-query").data('page');
        if(term != ""){
            window.location = baseURL + '/'+page+'?q=' + term;
        }

    });

    $("#s-query").keypress(function(e){
        if(e.which == 13) {
            var term = $(this).val();
            var page = $(this).data('page');
            if(term != ""){
                window.location = baseURL + '/'+page+'?q=' + term;
            }
        }
    });

    $(document).on('click', '#modeul-app-search', function(e) {
        e.preventDefault();

        var url = '';
        if ($('#scity option:selected').val() != '') {
            url += '?c=' + $('#scity option:selected').val();
        }

        if ($('#sap_type option:selected').val() != '') {
            if (url == '') {
                url += '?t=' + $('#sap_type option:selected').val();
            } else {
                url += '&t=' + $('#sap_type option:selected').val();
            }
        }


        window.location = baseURL + '/' + $(this).data('page') + url;
    });


    $(".dropdown-toggle").mouseenter(function(event) {
        // console.log($(this).attr('id'));
        $('.' + $(this).attr('id')).addClass('show');
    }).mouseleave(function(event) {
        // console.log('mouse out');
    });

    $("ul.dropdown-menu [data-toggle='dropdown']").on("click", function(event) {
        event.preventDefault();
        event.stopPropagation();

        $(this).siblings().toggleClass("show");


        if (!$(this).next().hasClass('show')) {
            $(this).parents('.dropdown-menu').first().find('.show').removeClass("show");
        }
        $(this).parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function(e) {
            $('.dropdown-submenu .show').removeClass("show");
        });

    });
    // var images = document.querySelectorAll('.section-bg.parallaxed');
    // new simpleParallax(images, {
    //     orientation: 'up',
    //     delay: 0,
    //     transition: 'cubic-bezier(0.215, 0.610, 0.355, 1)',
    // });

     // Add smooth scrolling to all links
     $(".scroll-to").on('click', function(event) {
        // Make sure this.hash has a value before overriding default behavior
        if (this.hash !== "") {
            // Prevent default anchor click behavior
            event.preventDefault();

            // Store hash
            var hash = this.hash;

            // Using jQuery's animate() method to add smooth page scroll
            // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
            $('html, body').animate({
                scrollTop: $(hash).offset().top
            }, 800, function(){

                // Add hash (#) to URL when done scrolling (default click behavior)
                window.location.hash = hash;
            });
        } // End if
    });
    var swiper = new Swiper('.swiper-container.template-project-index', {
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        navigation: {
            nextEl: '.swiper-button-prev.project-prev',
            prevEl: '.swiper-button-next.project-next',
        },
    });
    var swiperCategories = new Swiper('.swiper-container.template-tabs', {
        // slidesPerView: 6,
        // freeMode: true,
        // spaceBetween: 10,
        watchOverflow: true,
        navigation: {
            nextEl: '.swiper-button-prev.category-prev',
            prevEl: '.swiper-button-next.category-next',
        },
        breakpoints: {
            // when window width is >= 320px
            320: {
              slidesPerView: 3,
              spaceBetween: 5
            },
            // when window width is >= 768px
            768: {
              slidesPerView: 3,
              spaceBetween: 25
            },
            // when window width is >= 640px
            1024: {
              slidesPerView: 3,
              spaceBetween: 25
            },
            1200: {
              slidesPerView: 5,
              spaceBetween: 10
            }
        }
    });

    var galleryThumbs = new Swiper('.gallery-thumbs', {
        spaceBetween: 10,
        // slidesPerView: 6,
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        navigation: {
            nextEl: '.swiper-button-prev.thumb-prev',
            prevEl: '.swiper-button-next.thumb-next',
        },
        breakpoints: {
            // when window width is >= 320px
            320: {
              slidesPerView: 3,
              spaceBetween: 5
            },
            // when window width is >= 768px
            768: {
              slidesPerView: 3,
              spaceBetween: 25
            },
            // when window width is >= 640px
            1024: {
              slidesPerView: 3,
              spaceBetween: 25
            },
            1200: {
              slidesPerView: 6,
              spaceBetween: 10
            }
        }
    });
    var galleryTop = new Swiper('.gallery-top', {
        spaceBetween: 10,
        effect: 'fade',
        speed: 1000,
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.swiper-button-prev.gallery-prev',
            prevEl: '.swiper-button-next.gallery-next',
        },
        thumbs: {
          swiper: galleryThumbs
        }
    });


    if ($(window).width() < 768)
    {
        var swiperBenefit = new Swiper('.swiper-container.template-benefits', {
            navigation: {
                nextEl: '.swiper-button-prev.benefit-prev',
                prevEl: '.swiper-button-next.benefit-next',
            },
        });
    }
    var swiperBlueprint = new Swiper('.swiper-container.template-blueprints', {
        slidesPerView: 4,
        spaceBetween: 20,
        //loop: true,
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        navigation: {
            nextEl: '.swiper-button-prev.blueprint-prev',
            prevEl: '.swiper-button-next.blueprint-next',
        },
        breakpoints: {
            // when window width is >= 320px
            320: {
              slidesPerView: 1,
              spaceBetween: 20
            },
            // when window width is >= 768px
            768: {
              slidesPerView: 2,
              spaceBetween: 25
            },
            // when window width is >= 640px
            1024: {
              slidesPerView: 3,
              spaceBetween: 25
            },
            1200: {
              slidesPerView: 4,
              spaceBetween: 20
            },
        }
    });

    var swiperGrid = new Swiper('.swiper-container.template-grid', {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        navigation: {
            nextEl: '.swiper-button-prev.grid-prev',
            prevEl: '.swiper-button-next.grid-next',
        },
    });

    if ( $(".card.template-blueprint").length > 0 ) {
        var lightbox = $('.card.template-blueprint').simpleLightbox({
            navText: ['<i class="fas fa-chevron-left"></i>','<i class="fas fa-chevron-right"></i>']
        });
    }
    if ($(".lightboxed-item").length > 0) {
        var lightboxSlider = $('.swiper-slide .lightboxed-item').simpleLightbox({
            navText: ['<i class="fas fa-chevron-left"></i>','<i class="fas fa-chevron-right"></i>']
        });
        $('.swiper-slide .lightboxed-item').on('shown.simplelightbox', function () {
            // do something…
            $('.swiper-button-prev').fadeOut();
            $('.swiper-button-next').fadeOut();
        });
        $('.swiper-slide .lightboxed-item').on('closed.simplelightbox', function () {
            // do something…
            $('.swiper-button-prev').fadeIn();
            $('.swiper-button-next').fadeIn();
        });
    }

    if ($(".table-lightbox").length > 0) {
        $('[data-lightbox]').each(function(index, element) {
            if (element.children.length > 0) {
                var lightboxSlider = $(element.children).simpleLightbox({
                    navText: ['<i class="fas fa-chevron-left"></i>','<i class="fas fa-chevron-right"></i>']
                });
            }
        });
    }
    if ( $( ".view-tab" ).length ) {
        $('.view-tab').on('click', function (e) {
            e.preventDefault();
            $('#myTab a[href="#data"]').tab('show');
        });
    }
    menuBtn();
    handlePreloader();
    wow.init();

    if ($(".template-stats").length > 0) {
        var waypoint = new Waypoint({
            element: document.getElementsByClassName('template-stats'),
            handler: function(direction) {
                counterItems();
            },
            offset: "25%"
        });
    }


    if ( $('.table-responsive').length > 0 ) {
        new PerfectScrollbar('.table-responsive');
    }

    $( ".open-submenu" ).click(function() {
        // console.log($(this).siblings('ul'));
        $(this).parent('li').toggleClass('active').siblings('li').removeClass('active');
        $(this).siblings('ul').slideToggle();
    });
    if ( $('.navbar-nav').children('li').hasClass('active') ) {
        // console.log('works');
    }

    if ( $('.btn-cta').length > 0 ) {
        $(window).scroll(function() {
            if ($('body').height() <= ($(window).height() + $(window).scrollTop())) {
                $('.btn-cta').removeClass('active');
            } else
            {
                $('.btn-cta').addClass('active');
            }
        });
    }
});
